import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import DeviceDetails from "./DeviceDetails";
import NoShow from "./NoShow";
import {
  fetchWifiNetworks,
  cancelWifiAction,
  finishWifiSetup,
  fetchDeviceMacAddress,
  finishMacFetch,
  getDevicesInfo,
} from "../../../../../actions";
import { uuidv4 } from "../../../../../utils/uuid";
import { compareVersions } from "../../../../../utils/versions";
import _ from "lodash";
import { useWebServer } from "../../../../../providers";

const Index = ({
  selectedDevice,
  device,
  fetchWifiNetworks,
  cancelWifiAction,
  finishWifiSetup,
  wifiStatus,
  fetchDeviceMacAddress,
  wifiName,
  fetchingMacAddressStatus,
  finishMacFetch,
  getDevicesInfo,
}) => {
  const { sendRequest } = useWebServer();

  const [id, setId] = useState(null);
  const [displayName, setDisplayName] = useState(null);
  const [firmwareVersion, setFirmwareVersion] = useState(null);
  const [algVersion, setAlgVersion] = useState(null);
  const [macAddress, setMacAddress] = useState(null);
  const [stateMachine, setStateMachine] = useState(null);
  const [hardwareId, setHardwareId] = useState(null);

  useEffect(() => {
    if (!device) {
      return;
    }
    setId(device?.id);
    setDisplayName(device?.displayName);
    setFirmwareVersion(device?.firmwareVersion);
    setAlgVersion(device?.algVersion);
    setStateMachine(device?.stateMachine);
    setMacAddress(device?.macAddress);
    setHardwareId(device?.hardwareId);
  }, [device]);

  useEffect(() => {
    getDevicesInfo(sendRequest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [curWifiName, setCurWifiName] = useState(null);
  const [wifiInit, setWifiInit] = useState(false);

  useEffect(() => {
    if (!wifiInit && wifiStatus === "ready") {
      setWifiInit(true);
      setCurWifiName(wifiName);
    }
  }, [wifiName, wifiInit, wifiStatus]);

  const [currentJob, setCurrentJob] = useState(null);

  const startFetchWifiJob = useCallback(() => {
    if (currentJob) {
      return;
    }
    const uuid = uuidv4();
    setCurrentJob(uuid);
    fetchWifiNetworks(selectedDevice, uuid);
  }, [fetchWifiNetworks, selectedDevice, currentJob]);

  const cancelRunningWifiJob = useCallback(() => {
    if (currentJob) {
      cancelWifiAction(currentJob);
      setCurrentJob(null);
    }
  }, [cancelWifiAction, currentJob]);

  useEffect(() => {
    if (selectedDevice && stateMachine === "IDLE") {
      startFetchWifiJob();
    }
    return () => {
      cancelRunningWifiJob();
      finishWifiSetup();
      finishMacFetch();
      //clean all wifi and mac address
      setWifiInit(false);
      setCurWifiName(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDevice, stateMachine]);

  //if the Wifi status is ready then fetch the mac address
  useEffect(() => {
    if (wifiStatus === "ready" && wifiName) {
      //check the mac address
      if (
        macAddress === "" ||
        (!macAddress?.includes("||") &&
          firmwareVersion &&
          compareVersions(firmwareVersion, "v3.5.0") >= 0)
      ) {
        const uuid = uuidv4();
        setCurrentJob(uuid);
        fetchDeviceMacAddress(selectedDevice, uuid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wifiStatus, wifiName, macAddress]);

  //clean fetch mac address jobs when it finish
  useEffect(() => {
    if (fetchingMacAddressStatus === "ready") {
      setCurrentJob(null);
    }
  }, [fetchingMacAddressStatus]);

  return (
    <>
      {selectedDevice ? (
        <DeviceDetails
          id={id}
          displayName={displayName}
          firmwareVersion={firmwareVersion}
          algVersion={algVersion}
          wifiName={stateMachine !== "OFF" ? curWifiName : "None"}
          wifiStatus={wifiStatus}
          macAddress={macAddress}
          hardwareId={hardwareId}
        />
      ) : (
        <NoShow />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const selectedDevice = state?.devices?.selectedDevice;
  const device = selectedDevice ? state?.devices?.[selectedDevice] || {} : {};
  const wifiStatus = state?.wifi?.status;
  const wifi = _.find(
    state?.wifi?.networks || {},
    (x) => x?.connected === true
  );
  const wifiName = wifi?.name || "Not find";
  const fetchingMacAddressStatus = state?.devices?.fetchingMacAddressStatus;
  return {
    currentWifi: state?.wifi?.currentConnectedWifi,
    selectedDevice: state?.devices?.selectedDevice,
    device,
    wifiStatus,
    wifiName,
    fetchingMacAddressStatus,
  };
};

export default connect(mapStateToProps, {
  fetchWifiNetworks,
  cancelWifiAction,
  finishWifiSetup,
  fetchDeviceMacAddress,
  finishMacFetch,
  getDevicesInfo,
})(Index);
